module.exports = __webpack_public_path__ + "static/media/lock.988f776a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/lock.svg
// module id = 1195
// module chunks = 0